import { useSelector, useDispatch } from "react-redux"
import { DefaultTemplate } from "./templates/DefaultTemplate"
import { useEffect } from "react"
import { setTemplate, setAllTemplates } from "./emailSlice"
import { selectLogInUsername } from "../../common/authenticateDashboard/authSlice"

export function EmailTemplates() {

    const dispatch = useDispatch()
    const template = useSelector((state) => state.emailCustomer.template)
    const allTemplates = useSelector((state) => state.emailCustomer.allTemplates)
    const sessionUser = useSelector(selectLogInUsername)
    const user = sessionUser?.split('@')[0];


    // Main data fetching function
    useEffect(() => {
        try {
            if (allTemplates.length === 0) {
                dispatch(setAllTemplates(['default', 'dummy template']))
            }
        } 
        catch (err) {
            console.log(err)
        }
    }, [])




    // Changes the template and updates the state
    const handleTemplateChange = (val) => {
        dispatch(setTemplate(val))
    }



    // Displays the current template
    function displayTemplate() {
        switch (template) {
            case 'default': return <DefaultTemplate user={user} />;
            default : return <DummyTemplate />;
        }
    }



    return (
        <div className='flex flex-col'>
            {/* Title */}
            <div className='h-10 mt-2 fs-5 fw-bold' style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                Email Templates
            </div>
            <div className='flex gap-3 mt-3 pb-3 mb-3 items-center' style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                <div className=''>Template: </div>
                <select className='rounded-2 border-1 border-black border-solid focus:outline-0 p-1 px-2 cursor-pointer' defaultValue='default' onChange={(e) => handleTemplateChange(e.target.value)}>
                    {allTemplates?.map((val, index) => (
                        <option key={index} value={val}>{val}</option>
                    ))}
                </select>
            </div>
            {displayTemplate()}
        </div>
    )
}






function DummyTemplate() {
    return (
        <div>Dummy template to be deleted at bottom of main file</div>
    )
}